var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExproLogoStanding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1511.8134 1511.8134",
    height: 1511.8134,
    width: 1511.8134,
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1511.8133)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2808.83,3659.81 h -95.76 V 2254.67 h 941.27 v 255.15 h -676.45 v 315.01 h 570.25 v 255.15 h -570.25 v 324.68 h 676.45 v 255.15 h -676.45 -169.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4843.13,3659.81 h -279.39 l -264.21,-451.6 -267.31,451.6 h -279.21 l 407.88,-688.48 -419.53,-716.66 h 279.38 l 280.7,479.54 283.54,-479.54 h 279.39 l -424.61,715.89 403.37,689.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5748.6,3137.95 c -13.54,-26.46 -32.38,-46.84 -56.53,-61.31 -24.16,-14.56 -52.08,-21.76 -83.59,-21.76 h -305.42 v 349.78 h 305.42 c 32.2,0 60.47,-7.19 84.62,-21.75 24.15,-14.48 42.82,-35.11 56.01,-61.84 13.19,-26.72 19.87,-57.47 19.87,-92.24 0,-34.18 -6.85,-64.5 -20.38,-90.88 z m 84.62,468.25 c -66.81,35.71 -143.89,53.61 -231.42,53.61 H 5303.06 5159.17 5038.23 V 2254.67 h 264.83 v 545.06 h 298.74 c 87.53,0 164.61,17.74 231.42,53.11 66.63,35.46 118.36,85.56 155.01,150.31 36.67,64.75 55.16,139.94 55.16,225.68 0,85.65 -18.49,161.02 -55.16,226.11 -36.65,65.09 -88.38,115.46 -155.01,151.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6515.82,3405.61 h 329.58 c 27.75,0 51.9,-6.68 72.45,-20.21 20.74,-13.54 36.66,-32.89 47.97,-57.99 11.14,-25.18 16.79,-54.13 16.79,-87.01 -0.52,-32.89 -6.51,-61.85 -17.82,-86.94 -11.3,-25.18 -27.24,-44.45 -47.79,-57.99 -20.73,-13.52 -44.54,-20.29 -71.6,-20.29 h -329.58 z m 554.32,-533.42 c 58.92,34.78 104.49,83.94 136.69,147.41 32.21,63.45 48.31,137.03 48.31,220.8 0,83.76 -16.1,157.33 -48.31,220.79 -32.2,63.46 -77.59,112.62 -136.17,147.4 -58.59,34.78 -126.6,52.16 -204.02,52.16 H 6515.82 6356.53 6251.17 V 2254.67 h 264.65 v 565.36 h 160.73 l 316.68,-565.36 h 321 L 6978.24,2834 c 32.71,8.69 63.37,21.36 91.9,38.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8225.52,2751.43 c 0,-48.99 -9.93,-92.16 -29.45,-129.5 -19.71,-37.42 -47.63,-66.2 -83.6,-86.5 -36.14,-20.3 -78.11,-30.49 -125.73,-30.49 -47.62,0 -89.59,10.19 -125.56,30.49 -36.15,20.3 -64.07,49.08 -83.59,86.5 -19.71,37.34 -29.46,80.51 -29.46,129.5 v 411.62 c 0,49 9.75,92.16 29.46,129.5 19.52,37.43 47.44,66.21 83.59,86.51 35.97,20.29 77.94,30.49 125.56,30.49 47.62,0 89.59,-10.2 125.73,-30.49 35.97,-20.3 63.89,-49.08 83.6,-86.51 19.52,-37.34 29.45,-80.5 29.45,-129.5 z m 210.69,676.95 c -42.64,78.3 -102.59,138.84 -180.37,181.66 -77.6,42.83 -167.35,64.24 -269.1,64.24 -101.75,0 -191.51,-21.41 -269.1,-64.24 -77.6,-42.82 -137.73,-103.36 -180.21,-181.66 -42.48,-78.28 -63.89,-168.97 -63.89,-272.1 V 2758.2 c 0,-103.13 21.41,-193.82 63.89,-272.1 42.48,-78.28 102.61,-138.84 180.21,-181.66 77.59,-42.83 167.35,-64.24 269.1,-64.24 101.75,0 191.5,21.41 269.1,64.24 77.78,42.82 137.73,103.38 180.37,181.66 42.49,78.28 63.73,168.97 63.73,272.1 v 398.08 c 0,103.13 -21.24,193.82 -63.73,272.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3866.2,4474.34 c 9.68,0 18.17,-2.37 25.41,-7.18 7.31,-4.74 12.9,-11.59 16.86,-20.41 4.01,-8.82 5.99,-19.03 5.99,-30.47 0,-11.26 -2.05,-21.27 -6.13,-30.03 -4.08,-8.75 -9.74,-15.47 -16.98,-20.28 -7.25,-4.8 -15.67,-7.18 -25.15,-7.18 h -91.77 v 115.55 z m -91.77,-199.81 h 89.72 c 26.34,0 49.58,5.86 69.59,17.58 20.09,11.65 35.63,28.24 46.61,49.63 11.07,21.33 16.6,46.22 16.6,74.54 0,28.3 -5.53,53.19 -16.6,74.71 -10.98,21.47 -26.52,38.12 -46.61,49.97 -20.01,11.78 -43.25,17.71 -69.59,17.71 h -89.72 -43.26 -36.33 v -464.2 h 79.59 v 180.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4306.51,4258.53 c 0,-16.13 -2.97,-30.42 -8.9,-42.72 -5.92,-12.39 -14.28,-21.93 -25.15,-28.65 -10.86,-6.65 -23.43,-10 -37.72,-10 -14.35,0 -26.93,3.35 -37.78,10 -10.87,6.72 -19.23,16.26 -25.16,28.65 -5.85,12.3 -8.82,26.59 -8.82,42.72 v 136.02 c 0,16.19 2.97,30.41 8.82,42.79 5.93,12.31 14.29,21.86 25.16,28.56 10.85,6.72 23.43,10.08 37.78,10.08 14.29,0 26.86,-3.36 37.72,-10.08 10.87,-6.7 19.23,-16.25 25.15,-28.56 5.93,-12.38 8.9,-26.6 8.9,-42.79 z m 9.15,283.68 c -23.38,14.15 -50.37,21.2 -80.92,21.2 -30.62,0 -57.6,-7.05 -80.91,-21.2 -23.37,-14.16 -41.41,-34.17 -54.18,-60.04 -12.77,-25.88 -19.16,-55.83 -19.16,-89.86 v -131.54 c 0,-34.04 6.39,-64 19.16,-89.87 12.77,-25.87 30.81,-45.88 54.18,-60.03 23.31,-14.17 50.29,-21.21 80.91,-21.21 30.55,0 57.54,7.04 80.92,21.21 23.3,14.15 41.33,34.16 54.11,60.03 12.84,25.87 19.22,55.83 19.22,89.87 v 131.54 c 0,34.03 -6.38,63.98 -19.22,89.86 -12.78,25.87 -30.81,45.88 -54.11,60.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4821.07,4248.98 -80.78,309.69 h -63.93 l -80.71,-309.69 -54.38,309.69 h -81.9 l 97.3,-464.2 h 74.99 l 78.41,324.36 74.98,-324.36 h 74.92 l 97.31,464.2 h -81.9 l -54.31,-309.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5322.27,4474.34 v 84.33 h -282.96 v -464.2 h 28.77 50.82 203.37 v 84.27 H 5118.9 v 104.08 h 171.37 v 84.28 H 5118.9 v 107.24 h 203.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5639.19,4391.38 c -3.42,-8.29 -8.23,-14.68 -14.41,-19.15 -6.19,-4.48 -13.37,-6.72 -21.47,-6.72 h -99.08 v 109.15 h 99.08 c 8.29,0 15.54,-2.23 21.79,-6.65 6.19,-4.47 11,-10.86 14.36,-19.15 3.35,-8.37 5.06,-17.91 5.06,-28.77 -0.19,-10.87 -1.97,-20.41 -5.33,-28.71 z m 72.75,-44.24 c 9.67,20.94 14.55,45.3 14.55,72.95 0,27.65 -4.88,52.01 -14.55,72.94 -9.68,21.01 -23.37,37.2 -40.95,48.72 -17.65,11.46 -38.05,17.25 -61.29,17.25 h -105.47 -47.93 -31.66 v -464.53 h 79.59 v 186.78 h 48.27 l 95.26,-186.78 h 96.44 l -100.99,191.38 c 9.82,2.86 19.04,7.03 27.65,12.57 17.71,11.53 31.4,27.79 41.08,48.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5870.93,4558.67 h -28.77 v -464.2 h 282.96 v 84.27 h -203.36 v 104.08 h 171.37 v 84.28 h -171.37 v 107.24 h 203.36 v 84.33 h -203.36 -50.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6368.97,4474.34 c 26.14,0 46.34,-6.91 60.7,-20.74 14.36,-13.83 21.52,-33.38 21.52,-58.73 V 4258.2 c 0,-25.28 -7.16,-44.89 -21.52,-58.72 -14.36,-13.83 -34.56,-20.74 -60.7,-20.74 h -61.89 v 295.6 z m -61.89,-379.87 h 59.85 c 36.21,0 66.82,6.91 91.77,20.74 25.02,13.82 43.71,33.17 56.22,58.13 12.51,24.89 18.76,54.05 18.76,87.43 v 131.54 c 0,35.16 -6.51,65.11 -19.48,90.06 -12.97,24.88 -31.93,43.85 -56.81,56.82 -24.89,12.96 -54.91,19.48 -90.2,19.48 h -60.11 -39.49 -40.1 v -464.2 h 40.1 39.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7045.03,4388.48 c -9.02,-9.15 -21.73,-13.75 -38.19,-13.75 h -90.06 v 99.61 h 90.06 c 16.46,0 29.17,-4.15 38.19,-12.45 9.02,-8.29 13.49,-19.88 13.49,-34.76 0,-16.59 -4.47,-29.49 -13.49,-38.65 z m 12.37,-123.56 c 4.42,-8.3 6.66,-18.3 6.66,-30.02 v -0.93 c 0,-17.44 -5.01,-31.01 -14.95,-40.68 -10.01,-9.75 -24.1,-14.55 -42.27,-14.55 h -90.06 v 111.72 h 90.06 c 11.98,0 22.32,-2.17 30.95,-6.52 8.62,-4.34 15.14,-10.73 19.61,-19.02 z m 71.57,119.88 c 6.51,13.96 9.74,29.95 9.74,48.06 0,26.4 -5.01,48.98 -15.07,67.88 -10.08,18.83 -24.83,33.18 -44.18,43.05 -19.36,9.95 -42.73,14.88 -69.98,14.88 h -92.7 -44.77 -34.82 v -464.2 h 34.82 44.77 97.64 c 27.25,0 50.69,4.94 70.1,14.81 19.5,9.94 34.31,24.36 44.45,43.25 10.2,18.97 15.27,41.74 15.27,68.34 v 0.99 c 0,20.41 -3.43,38.38 -10.33,53.92 -6.86,15.53 -16.93,28.18 -30.23,37.86 -13.23,9.68 -29.16,15.86 -47.72,18.69 17.37,3.16 32.32,9.22 44.7,18.17 12.38,8.96 21.85,20.35 28.31,34.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7434.84,4558.67 -80.78,-199.88 -80.72,199.88 h -83.41 l 124.36,-285.13 v -179.07 h 79.6 v 179.07 l 124.3,285.13 h -83.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5548.94,6140 c 19.35,-1.09 38.66,-1.63 57.81,-1.63 70.29,0 141.4,7.22 211.33,21.46 181.54,36.95 350.74,121.63 489.31,244.89 17.37,15.49 32.19,29.4 46.61,43.8 13.68,13.69 27.65,28.58 42.68,45.52 123.26,138.54 207.92,307.72 244.88,489.25 28.71,140.97 28.54,283.96 -0.49,425.01 -39.56,192.18 -132.16,369.28 -267.67,512.05 l -5.53,5.89 c -4.55,4.88 -9.13,9.76 -13.9,14.53 l -557.66,557.64 423.32,423.31 L 7945.87,7195.5 6219.63,5469.28 Z M 6219.63,9300.44 5606.49,8687.3 4993.35,9300.44 2888.43,7195.5 4993.35,5090.56 l 418.86,418.85 -189.37,189.37 -229.49,-229.5 -1726.22,1726.22 1726.24,1726.24 1188.4,-1188.41 c 279.36,-297.4 287.24,-751.97 19.43,-1056.19 l -74.7,-74.83 c -143.46,-126.48 -328.03,-196.14 -519.75,-196.14 -193.45,0 -378.96,70.41 -521.27,197.26 l -67.9,67.82 c -273.17,306.53 -262.92,777.31 23.09,1071.5 l 374.6,374.6 -189.57,189.57 -366.15,-366.14 c -1.85,-1.86 -8.73,-9.17 -8.73,-9.18 -141.27,-144.63 -237.47,-325.35 -278.2,-522.59 -29.24,-141.51 -29.41,-284.98 -0.52,-426.42 37.42,-183.15 123.21,-353.43 248.09,-492.47 13.8,-15.34 26.66,-28.91 40.42,-42.68 12.92,-12.92 26.6,-25.86 39.65,-37.48 L 6219.63,5090.56 8324.59,7195.5 6219.63,9300.44"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExproLogoStanding);
export default __webpack_public_path__ + "static/media/expro_logo_standing.f6b7265b3186aa4a3b731cbe1630e39a.svg";
export { ForwardRef as ReactComponent };